import React, {
    Suspense, lazy, useMemo, useCallback,
} from 'react';

import { Box } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter, Switch, Route } from 'react-router-dom';

import { connectScreenSize } from '~/helpers/screen-size-helper';
import useClassNames from '~/hooks/use-classnames';
import { allRoutes } from '~/routes/app';
import { hasRoutePermission, renderRoute } from '~/routes/manager';

import styles from './AppRoutes.module.scss';
/* eslint-disable import/no-cycle */
const NotFoundPage = lazy(() => import('~/domains/errors/NotFoundPage'));

const AppRoutes = ({
    isDesktop,
    sidebarCollapsed,
}) => {
    const routes = useMemo(() => allRoutes.filter(hasRoutePermission), []);

    const contentClasses = useClassNames([
        styles.content, { [styles.fullContent]: !isDesktop || sidebarCollapsed },
    ]);

    const renderNotFound = useCallback(props => (
        <NotFoundPage {...props} returnPath="/app" />
    ), []);

    return (
        <Box className={contentClasses}>
            <Suspense fallback={<div>Carregando...</div>}>
                <Switch>
                    {routes.map((route, index) => renderRoute(route, index, '/app'))}
                    <Route render={renderNotFound} />
                </Switch>
            </Suspense>
        </Box>
    );
};

const mapStateToProps = state => ({
    tipoMenu: state.tipoMenuChangeHandler,
    sidebarCollapsed: state.sidebarCollapsed,
});

export default withRouter(connect(mapStateToProps)(connectScreenSize(AppRoutes)));
